var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result"},[_c('div',{staticClass:"result-cointainer"},[_c('img',{staticClass:"result_img",attrs:{"src":_vm.result,"alt":""}}),_c('h3',[_vm._v("当前阶段认证已通过")])])])}
var staticRenderFns = []

export { render, staticRenderFns }